
export const communityFeatures = [ 
    {
        icon: '../../../assets/images/spotlight.png',
        title: 'The Spotlight',
        description: 'Give us feedback on future projects we are planning to produce and take part in the creative process.'
    },
    {
        icon: '../../../assets/images/readers_room.png',
        title: 'The Reader’s Room',
        description: 'Exchange with fellow members on the movies, artworks, and meme’s you love. And be the first to learn about upcoming releases and future events.'
    },
    {
        icon: '../../../assets/images/hashrate_tv.png',
        title: 'Hashrate.TV',
        description: 'Gain access to Masterclass content, exclusive films, and inspiring content that are only available to the Hashrate community.'
    },
    {
        icon: '../../../assets/images/writers_workshop.png',
        title: 'Writer’s Workshop',
        description: '‍Submit your own script. If the community loves it – we’ll produce it!'
    },
]